export const ONETRUST_COOKIE_SETTING_BUTTON_ID = 'ot-sdk-btn';
export const ONETRUST_COOKIE_SETTING_BUTTON_CLASSNAME = 'ot-sdk-show-settings';
export const ONETRUST_COOKIE_SETTING_TEST_ID = 'one-trust-cookie-setting-button';

// TODO: use texts from CMS for aria-labels, once contentful is used as CMS
export const ariaLabels = {
    social: 'Socialiniai tinklai',
    navigation: 'Navigacija',
    contacts: 'Kontaktai',
    additional: 'Teisinė informacija',
};
